import { withRouter, Link } from 'react-router-dom';
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { types } from 'mobx-state-tree';
import LoggedinUser from '../../models/LoggedinUser';
import ListErrors from '../../components/ListErrors';
import InitiateForm from '../../components/loginforms/InitiateForm';
import ConfirmForm from '../../components/loginforms/ConfirmForm';
import PasswordForm from '../../components/loginforms/PasswordForm';
import Button from '@material-ui/core/Button';
import Footer from '../../components/footer/Footer';
import { getNoBrand } from 'src';

// css
const loginstyle = require('./login.css');


interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class Login extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  render() {
    const errors: string = this.props.loggedinUser.properties.errors;
    const callTo: string = 'tel:';
    const footerPhonenumber: string = callTo.concat(this.props.loggedinUser.branding.fullPhoneNumber);

    const astyle = {
      color: '#F24962',
    };

    const imageStyle = {
      width: '100%',
      height: '30px',
      backgroundSize: 'cover'
    };

    // images
    //const branding = 'tellit';
    const noBrand = getNoBrand();
    const branding = noBrand ? ('nobrand') : (this.props.loggedinUser.branding.brandingName);
    const imgLogo = require('../../images/branding/' + branding + '/logo32x32.png');
    const imgLogIn = require('../../images/branding/' + branding + '/loginAndNotSubscriber_bg.jpg');
    const imgWelcome = require('../../images/stars48x48.png');
  
    let buttonClass;
    if (branding ==='tellit'){
      buttonClass = "LogIn_button_features_headline_tellit";
    } else {
      buttonClass = "LogIn_button_features_headline";
    }

    let form;
    if (this.props.loggedinUser.view.loginForm === 'initiatelogin') {
      form = <InitiateForm loggedinUser={this.props.loggedinUser} />;
    } else if (this.props.loggedinUser.view.loginForm === 'confirmlogin') {
      form = <ConfirmForm loggedinUser={this.props.loggedinUser} />;
    } else if (this.props.loggedinUser.view.loginForm === 'passwordlogin') {
      form = <PasswordForm loggedinUser={this.props.loggedinUser} />;
    }

    return (
      <div className="auth-page">
        <div className="container page">
          <div className="row">
            <div className="login-imgdiv">
              <div className="login-image">
                <img src={imgLogIn} style={imageStyle} alt="Login" />
              </div>
              <div className="grid-div">
                <div className="login_grid">
                  <div className="login_header_box">
                    {noBrand ? (
                      <div>Mina sidor</div>
                    ) : (
                    <div>Mitt {this.props.loggedinUser.branding.displayName}</div>
                    )}
                  </div>
                  {form}
                </div>
              </div>
            </div>
            <div className="features_grid">
              <div className="features_headline_box">
                <h2 className="features_headline"><img src={imgWelcome} className="login_logo" />Välkommen</h2>
                {noBrand ? (
                  <h6 className="features_headline_2">till en operatör med bra priser och hög kundnöjdhet. Hos oss kommer du att trivas!</h6>
                ) : (
                  <h6 className="features_headline_2">till en operatör med bra priser och hög kundnöjdhet. Hos {this.props.loggedinUser.branding.displayName} kommer du att trivas!</h6>
                )}
              </div>
              <div className="features_smaller_headline_box">
              {noBrand ? (
                 <div/> 
              ) : (
                <Button
                  variant="raised"
                  className={buttonClass}
                  href={this.props.loggedinUser.branding.mainUrl}
                  disabled={false}
                  fullWidth={false}
                  size="small"
                >
                  Läs mer
                </Button>
              )}
                {/* <div>Läs mer om {this.props.loggedinUser.branding.displayName} på <a href={this.props.loggedinUser.branding.mainUrl} style={astyle}>{this.props.loggedinUser.branding.brandingName}.se</a> eller <a href={footerPhonenumber} style={astyle}>ring oss!</a></div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="footerDiv">
          <Footer loggedinUser={this.props.loggedinUser} />
        </div>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/Login.tsx